<template>
  <v-container id="search-dashboard" class="px-0 py-0" fluid v-if="isAdministrator">
    <v-toolbar id="search-toolbar" flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" icon @click="$refs.refSearchFilters.open()"><v-icon>mdi-magnify</v-icon></v-btn>
        </template>
        <span>Filtri di ricerca</span>
      </v-tooltip>
      <v-chip-group>
        <v-chip v-for="(x, i) in chips" :key="i">
          {{ x.key }}: <span class="font-weight-medium">{{ x.val }}</span>
        </v-chip>
      </v-chip-group>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" icon @click="generateReport()"><v-icon>mdi-printer</v-icon></v-btn>
        </template>
        <span>Stampa report</span>
      </v-tooltip>
    </v-toolbar>

    <v-divider></v-divider>

    <v-row>
      <v-col cols="12" class="px-0 py-0">
        <v-data-table :headers="headers" :items="events" item-key="id" :loading="loading"
          loading-text="Ricerca delle registrazioni in corso..." no-data-text="Nessuna registrazione trovata con i filtri attuali"
          :height="tableHeight" v-resize="adaptTable"
          fixed-header disable-pagination hide-default-footer>
          <template v-slot:item.datReport="props">
            {{ formatDate(props.item.datReport) }}
          </template>
          <template v-slot:item.datStart="props">
            {{ formatTime(props.item.datStart) }} &mdash; {{ formatTime(props.item.datEnd) }}<br/>
            <span class="caption grey--text font-weight-medium">{{ formatDuration(props.item.datStart, props.item.datEnd) }}</span>
          </template>
          <template v-slot:item.activity.description="props">
            {{ props.item.activity.description }}<br/>
            <span class="caption grey--text font-weight-medium">
              <v-icon left size="14" :color="getColor(props.item.area.id)">mdi-circle</v-icon>
              {{ props.item.area.description }}
            </span>
          </template>
          <template v-slot:item.user.fullName="props">
            {{ props.item.user.fullName }}<br/>
            <span class="caption grey--text font-weight-medium">{{ props.item.user.username }}</span>
          </template>
          <template v-slot:item.flagSmartWorking="props">
            <v-icon color="green">{{ (props.item.flagSmartWorking) ? 'mdi-check' : '' }}</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <search-filters ref="refSearchFilters" @filters="search"></search-filters>
    <report-form ref="refReportForm" :report="report"></report-form>
  </v-container>
</template>

<script>
import moment from 'moment';
import ReportFormVue from '../components/report/ReportForm.vue';
import SearchFiltersVue from '../components/search/SearchFilters.vue';
import { mapGetters } from 'vuex';
import apiRepository from '../api/api-repository';

require('moment-precise-range-plugin');
moment.locale('it');

export default {
  components: {
    'search-filters': SearchFiltersVue,
    'report-form': ReportFormVue,
  },

  data: ()=> ({
    // gestione del componente.
    loading: false,
    headers: [
      { text: 'Data attività', align: 'center', sortable: true, value: 'datReport' },
      { text: 'Orario', align: 'start', sortable: true, value: 'datStart' },
      { text: 'Attività', align: 'start', sortable: true, value: 'activity.description' },
      { text: 'Utente', align: 'start', sortable: true, value: 'user.fullName' },
      { text: 'Smart Working', align: 'center', sortable: true, value: 'flagSmartWorking' }
    ],
    tableHeight: null, // altezza della tabella.
    filterMenu: false, // apre/chiude il menu contenente i filtri di ricerca.
    events: new Array(), // risultato della ricerca.
    // gestione dei filtri di ricerca.
    chips: new Object(),
    filters: new Object(), 
    // gestione del form di generazione del report.
    report: new Object(),

    colors: [ 'cyan', 'green', 'orange', 'red', 'purple', 'blue', 'light-blue', 'pink', 'yellow', 'grey' ],
    areaColors: [ ],
  }),

  computed: {
    ...mapGetters('oidcStore', [ 'oidcIsAuthenticated', 'oidcUser', 'oidcAccessToken' ]),
    ...mapGetters('argoStore', [ 'isAdministrator' ]),
  },

  methods: {
    async search(filters){
      this.loading = true;

      let req = { from: (filters) ? filters.from : moment().isoWeekday(1).format('YYYY-MM-DD'), 
        to: (filters) ? filters.to : moment().isoWeekday(7).format('YYYY-MM-DD'),
        areaId: (filters && filters.area) ? filters.area.id : null,
        activityId: (filters && filters.activity) ? filters.activity.id : null };
  
      if(this.isAdministrator) req.userId = (filters && filters.user) ? filters.user.id : null;

      try{
        const res = await apiRepository.search().search(req);
        this.events = res.data;
        this.updateFilters(filters);
        this.loading = false;
      }
      catch(e){
        console.error('exception:', e);
      }
    },

    updateFilters(filters){
      let chips = new Array();

      if(filters) chips.push({ key: 'dal', val: moment(filters.from).format('DD/MM/YYYY') });
      else chips.push({ key: 'dal', val: moment().isoWeekday(1).format('DD/MM/YYYY') });

      if(filters) chips.push({ key: 'al', val: moment(filters.to).format('DD/MM/YYYY') });
      else chips.push({ key: 'al', val: moment().isoWeekday(7).format('DD/MM/YYYY') });

      if(filters && filters.area) chips.push({ key: 'area', val: filters.area.description });
      if(filters && filters.activity) chips.push({ key: 'attività', val: filters.activity.description });
      if(filters && filters.user) chips.push({ key: 'utente', val: `${filters.user.fullName}` });

      this.chips = chips;
      this.filters = filters;
    },

    generateReport(){
      this.report = { 
        from: (this.filters) ? this.filters.from : moment().isoWeekday(1).format('YYYY-MM-DD'), 
        to: (this.filters) ? this.filters.to : moment().isoWeekday(7).format('YYYY-MM-DD'), 
        areaId: (this.filters && this.filters.area) ? this.filters.area.id : null, 
        activityId: (this.filters && this.filters.activity) ? this.filters.activity.id : null 
      };

      if(this.isAdministrator) 
        this.report.userId = (this.filters && this.filters.user) ? this.filters.user.id : null;
      
      this.$refs.refReportForm.open();
    },

    formatDate(date){
      return moment(date).format('dddd, D MMMM YYYY');
    },

    formatTime(dateTime){
      return moment(dateTime).format('HH:mm');
    },

    formatDuration(start, end){
      const diff = moment.preciseDiff(start, end, true);
      let hours = '', minutes = '';
      
      if(diff.hours > 0 && diff.hours > 1) hours = `${diff.hours} ore`;
      else if(diff.hours > 0 && diff.hours == 1) hours = `${diff.hours} ora`;
      if(diff.minutes > 0) minutes = `${diff.minutes} minuti`;
      
      return (hours.length > 0) ? `${hours} ${minutes}` : `${minutes}`;
    },

    getColor(id){
      const color = this.areaColors.find((x)=> x.id === id);
      return (color) ? color.color : 'grey';
    },

    async setAreaColors(){
      let areaColors = [ ];
      const res = await apiRepository.area().findAll(), areas = res.data;

      for(let i = 0; i < areas.length; i++){
        const x = { id: areas[i].id, color: (i < this.colors.length) ? this.colors[i] : this.colors[(i - this.colors.length - 1)] };
        areaColors.push(x);
      }

      this.areaColors = areaColors;
    },

    adaptTable(){
      const yHeader = document.getElementById('tr-header').style.height.replace('px', '');
      const yToolbar = document.getElementById('search-toolbar').style.height;
      this.tableHeight = window.innerHeight - yHeader - yToolbar - 1;
    }
  },

  mounted(){
    this.adaptTable();
    this.search();
  },

  created(){
    this.setAreaColors();
  }
}
</script>
